export const COLUMNS = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  key: '1',
  align: 'center',
  width: 80,
  scopedSlots: {
    customRender: 'index'
  }
}, {
  slots: {
    title: '结算月份'
  },
  dataIndex: 'date',
  key: '3',
  align: 'center',
  width: 100
}, {
  slots: {
    title: '出单机构'
  },
  dataIndex: 'organizationName',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '保单号'
  },
  dataIndex: 'policyNo',
  key: '4',
  align: 'center',
  width: 150
}, {
  slots: {
    title: '保险公司'
  },
  dataIndex: 'organizationName',
  key: '5',
  align: 'center'
}, {
  slots: {
    title: '产品大类'
  },
  dataIndex: 'classificationName',
  key: '6',
  align: 'center',
  width: 100
}, {
  slots: {
    title: '产品名称'
  },
  dataIndex: 'customerInsuranceName',
  key: '7',
  align: 'center'
}, {
  slots: {
    title: '产品代码'
  },
  dataIndex: 'code',
  key: '9',
  align: 'center',
  width: 100
}, {
  slots: {
    title: '保费'
  },
  key: '8',
  align: 'center',
  width: 200,
  dataIndex: 'premium',
  width: 150
}];
export const data = [{
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  policyNo: '234',
  classificationName: '人身险',
  customerInsuranceName: '普惠版百万医疗',
  code: 'Code1',
  premium: '30',
  id: '1'
}];
export const TYPELIST = [{
  id: '1',
  name: '首期'
}, {
  id: '2',
  name: '续期'
}];